<template>
    <div class="kt-portlet__head">
        <form class="isprint-filter" autocomplete="off">
            <div class="row">
                <div class="form-group mt-1 mr-2 ml-4 float-left">
                    <label>Codice Agente</label><br />
                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                        placeholder="Codice Agente" type="text" style="width:150px"
                        v-model="search.CODICE_AGENTE.VALUE">
                </div>
                <div class="form-group mt-1 mr-2 float-left">
                    <label>Utente</label><br />
                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                        placeholder="Nome Utente" type="text" style="width:150px" v-model="search.USERNAME.VALUE">
                </div>
                <div class="form-group mt-1 mr-2 float-left">
                    <label>Agente</label><br />
                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                        placeholder="Descrizione Agente" type="text" style="width:150px"
                        v-model="search.DESCRIZIONE_AGENTE.VALUE">
                </div>
            </div>
            <button class="btn btn-success float-right btn-sm my-2 my-sm-3" v-on:click="creaAgente()"
                style="margin-top:26px"><i class="fal fa-plus"></i> Crea Agente</button>
        </form>
    </div>
    <div class="isprint-grid-container" style="margin-top: 20px;">
        <table class="isprint-grid shadow">
            <thead class="isprint-grid-thead">
                <tr style="left: 0px;background:#3A524F;color:#fff">
                    <th style="width:10%"><span>Codice Agente</span></th>
                    <th style="width:20%"><span>Utente</span></th>
                    <th style="width:60%"><span>Agente</span></th>
                    <th style="width:10%"><span>Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-for="agente in paginatedList.arr" v-bind:key="agente.ID_AGENTE">
                    <td style="width:10%">
                        <kbd style="font-size:16px">{{ agente.CODICE_AGENTE }}</kbd>
                    </td>
                    <td style="width:20%">
                        <span><i class="fas fa-user fa-2x text-secondary mr-2" aria-hidden="true"></i> <strong>{{
                            agente.USERNAME != null ? agente.USERNAME : 'Utente non selezionato' }}</strong></span>
                    </td>
                    <td style="width:60%">
                        <i class="fad fa-user-secret fa-2x mr-2" aria-hidden="true"></i>
                        <strong>{{ agente.DESCRIZIONE_AGENTE }}</strong>
                    </td>
                    <td style="width:10%; ">
                        <div class="btn-group float-right" role="group" aria-label="Basic example">
                            <button data-toggle="tooltip" data-placement="top" title="Modifica agente"
                                class="btn btn-warning btn-sm float-right" v-on:click="modificaAgente(agente)"><i
                                    class="fal fa-pencil"></i></button>
                            <button data-toggle="tooltip" data-placement="top" title="Elimina agente"
                                class="btn btn-danger btn-sm float-right" v-on:click="deleteAgente(agente)"><i
                                    class="fal fa-trash-alt"></i></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count"
            :numpagine="search.PAGINATION.LENGTH"></Pagine>
    </div>
    <div class="modal fade" id="popUpAgente" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog" style="min-width:800px;">
            <div class="modal-content">
                <div class="modal-header modal-header" style="background:#3A524F">
                    <h4 style="color:#fff" class="modal-title"><i class="fal fa-user-secret fa-fw"></i> Agente</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="height:120px">
                    <div class="row">
                        <div class="col-4">
                            <div class="form-group">
                                <label>Codice Agente:</label>
                                <input type="text" class="form-control form-control-sm"
                                    placeholder="Inserisci Codice Agente" v-model="agenteSelezionato.CODICE_AGENTE">
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <label>Agente:</label>
                                <input type="text" class="form-control form-control-sm"
                                    placeholder="Inserisci Descrizione" v-model="agenteSelezionato.DESCRIZIONE_AGENTE">
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <label>Utente:</label>
                                <Select2 v-model="agenteSelezionato.FK_ID_UTENTE" :w="189"
                                    :api="'es/utente/select2?a=1'" :apiselected="'es/utente/s2'"></Select2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaAgente()"><i class="fa fa-check"></i>
                        Salva</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagine from '@/components/utils/Pagine.vue'
import Select2 from '@/components/utils/Select2.vue'

export default {
    name: "Agenti",
    components: {
        Pagine,
        Select2
    },
    data: function () {
        return {
            filters: global.filters,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                USERNAME: { TYPE: 'TEXT', VALUE: '' },
                DESCRIZIONE_AGENTE: { TYPE: 'TEXT', VALUE: '' },
                CODICE_AGENTE: { TYPE: 'TEXT', VALUE: '' },
            },
            arrayAgenti: new Array(),
            agenteSelezionato: {}
        }
    },
    methods: {
        getAgenti: function () {
            global.utils.get('/es/agenti', {}, (response) => {
                this.arrayAgenti = response.data;
            });
        },
        creaAgente: function () {
            this.agenteSelezionato = { ID_AGENTE: 0 }
            var modal = utils.openModal('popUpAgente');
        },
        modificaAgente: function (agente) {
            this.agenteSelezionato = utils.clone(agente);
            var modal = utils.openModal('popUpAgente');
        },
        deleteAgente: function (agente) {
            utils.alert.confirm("Sei sicuro di voler eliminare l'agente selezionato?", () => {
                global.utils.delete('/es/agente', { ID_AGENTE: agente.ID_AGENTE }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getAgenti();
                    }
                });
            }, this.$root);
        },
        salvaAgente: function () {
            // Cast FK_ID_UTENTE a stringa
            const fkIdUtenteSelezionato = String(this.agenteSelezionato.FK_ID_UTENTE);

            // Controllo locale: Selezionare un utente
            if (this.agenteSelezionato.FK_ID_UTENTE == null) {
                utils.alert.warning("Selezionare un utente.");
                return; // Blocca l'esecuzione ulteriore
            }

            // Controllo locale: Verifica se l'utente è già associato a un altro agente
            const agenteEsistente = this.arrayAgenti.find(agente =>
                String(agente.FK_ID_UTENTE) === fkIdUtenteSelezionato &&
                agente.ID_AGENTE !== this.agenteSelezionato.ID_AGENTE && 
                agente.FK_ID_UTENTE != null
            );

            if (agenteEsistente) {
                utils.alert.warning("Questo utente è già associato a un agente.");
                return; // Blocca l'operazione
            }

            // Controllo locale: Verifica se il CODICE_AGENTE è già utilizzato
            const codiceAgenteEsistente = this.arrayAgenti.find(agente =>
                agente.CODICE_AGENTE === this.agenteSelezionato.CODICE_AGENTE &&
                agente.ID_AGENTE !== this.agenteSelezionato.ID_AGENTE
            );

            if (codiceAgenteEsistente) {
                utils.alert.warning("Il codice agente è già utilizzato,controllare se è vuoto");
                return;  
            }

            // Se tutti i controlli passano, procedi con il salvataggio
            if (this.agenteSelezionato.ID_AGENTE > 0) {
                // update
                global.utils.put('/es/agente', this.agenteSelezionato, (response) => {
                    if (response.esito === 0) {
                        this.getAgenti();
                        var modal = utils.closeModal('popUpAgente');
                        utils.alert.success(response.messaggio);
                    }
                });
            } else {
                // create
                global.utils.post('/es/agente', this.agenteSelezionato, (response) => {
                    if (response.esito === 0) {
                        this.getAgenti();
                        var modal = utils.closeModal('popUpAgente');
                        utils.alert.success(response.messaggio);
                    }
                });
            }
        }

    },
    computed: {
        paginatedList() {
            var arr = utils.inGrid(this.arrayAgenti, this.search);
            return arr;
        },
    },
    created: function () {
        this.getAgenti();
    },
}
</script>
